import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid
} from '@mui/material';
import { ParticipantData } from '@/types/signup';
import { useI18n } from '@/hooks/useI18n';

interface PersonalInfoSectionProps {
  signUpType: 'individual' | 'group';
  primaryParticipant: ParticipantData;
  email: string;
  phone: string;
  onPrimaryParticipantChange: (field: keyof ParticipantData, value: string | boolean | undefined) => void;
  onEmailChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
}

const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
  signUpType,
  primaryParticipant,
  email,
  phone,
  onPrimaryParticipantChange,
  onEmailChange,
  onPhoneChange
}) => {
  const { t } = useI18n();
  
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        👤 {signUpType === 'group' ? t('signup.primaryContactInfo') : t('signup.yourInformation')}
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={`👤 ${t('participant.fullName')}`}
            value={primaryParticipant.name}
            onChange={(e) => onPrimaryParticipantChange('name', e.target.value)}
            required
            placeholder={t('signup.enterFullName')}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={`🎂 ${t('participant.dateOfBirth')}`}
            type="date"
            value={primaryParticipant.dateOfBirth}
            onChange={(e) => onPrimaryParticipantChange('dateOfBirth', e.target.value)}
            required
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={`📧 ${t('common.email')}`}
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            required
            placeholder={t('signup.enterEmail')}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={`📞 ${t('common.phone')}`}
            value={phone}
            onChange={(e) => onPhoneChange(e.target.value)}
            required
            placeholder={t('signup.enterPhone')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PersonalInfoSection;
